import { render, staticRenderFns } from "./Precios.vue?vue&type=template&id=136218a0&"
import script from "./Precios.vue?vue&type=script&lang=js&"
export * from "./Precios.vue?vue&type=script&lang=js&"
import style0 from "./Precios.vue?vue&type=style&index=0&id=136218a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports